var map = {
	"./faculty_of_art,_design_and_architecture.jpg": [
		144,
		5
	],
	"./faculty_of_arts.jpg": [
		143,
		0
	],
	"./faculty_of_business_and_economics.jpg": [
		145,
		6
	],
	"./faculty_of_education.jpg": [
		146,
		7
	],
	"./faculty_of_engineering.jpg": [
		147,
		8
	],
	"./faculty_of_information_technology.jpg": [
		148,
		9
	],
	"./faculty_of_law.jpg": [
		149,
		10
	],
	"./faculty_of_medicine,_nursing_and_health_sciences.jpg": [
		150,
		11
	],
	"./faculty_of_pharmacy_and_pharmaceutical_sciences.jpg": [
		151,
		12
	],
	"./faculty_of_science.jpg": [
		152,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 138;
module.exports = webpackAsyncContext;